import React from "react";

import styles from "./EmptyList.module.scss";

const EmptyList = () => (
  <>
    <p className={styles.text}>ooops!!! we didn't find any movies</p>
  </>
);

export default EmptyList;
